/**
 * Help button (snippets/pl-help.liquid): opens and closes the help menu, and turns Shopify Inbox into a chat that
 * opens from the menu. Inbox renders its own pill inside <shopify-chat>'s open shadow root; once it is there, a style
 * in that shadow root hides the pill (its chat window, with its own close button, still opens), and the menu's chat
 * row appears. If Inbox never loads (blocked, app off), the row stays hidden and call/email still work.
 */
(() => {
  const root = document.querySelector('[data-pl-help]');
  if (!root) return;
  const toggle = root.querySelector('[data-pl-help-toggle]');
  const panel = root.querySelector('#pl-help-panel');
  const chatRow = root.querySelector('[data-pl-help-chat-row]');
  const chatBtn = root.querySelector('[data-pl-help-chat]');

  const setOpen = (open, focusBack) => {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    root.classList.toggle('is-open', open);
    if (open) {
      const first = panel.querySelector('li:not([hidden]) .pl-help__item');
      if (first) first.focus({preventScroll: true});
    } else if (focusBack) {
      toggle.focus({preventScroll: true});
    }
  };

  toggle.addEventListener('click', () => setOpen(panel.hidden));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !panel.hidden) setOpen(false, true);
  });
  document.addEventListener('click', (e) => {
    if (!panel.hidden && !root.contains(e.target)) setOpen(false);
  });

  /* Shopify Inbox: hide its pill, open its chat from the menu.
     Inbox nests shadow roots (<shopify-chat> → <shopify-agent-runtime> once the chat has been used) and re-renders
     them, so every shadow root under <shopify-chat> gets the hide rule as an adopted stylesheet (it survives
     re-renders), roots added later are picked up by a cheap periodic walk, and the menu clicks whichever pill exists. */
  const HIDE = 'button.activator,[class*="activator"]{display:none!important}';
  const roots = (host) => {
    const out = [];
    const walk = (sr) => {
      out.push(sr);
      for (const el of sr.querySelectorAll('*')) if (el.shadowRoot) walk(el.shadowRoot);
    };
    if (host && host.shadowRoot) walk(host.shadowRoot);
    return out;
  };
  const hideIn = (sr) => {
    if (sr.__plHelp) return;
    sr.__plHelp = true;
    try {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(HIDE);
      sr.adoptedStyleSheets = [...sr.adoptedStyleSheets, sheet];
    } catch (e) {
      const st = document.createElement('style');
      st.textContent = HIDE;
      sr.appendChild(st);
    }
  };
  const findPill = () => {
    for (const sr of roots(document.querySelector('shopify-chat'))) {
      const b = sr.querySelector('button.activator');
      if (b) return b;
    }
    return null;
  };
  const sweep = () => {
    const host = document.querySelector('shopify-chat');
    if (!host) return false;
    roots(host).forEach(hideIn);
    if (!findPill()) return false;
    chatRow.hidden = false;
    document.documentElement.classList.add('pl-help-chat');
    return true;
  };
  sweep();
  setInterval(sweep, 1500);

  chatBtn.addEventListener('click', () => {
    setOpen(false);
    const pill = findPill();
    if (pill) pill.click();
  });

  /* Never on top of a buy button (owner 2026-10-10: "call button and help overlaps atc button"). The bar floats
     bottom right; while it would cover add to cart, request a quote, a card's quick add, a Pairs with "Add", checkout or
     a form's send button, it steps aside (html.pl-help-clear), and comes back once that button has scrolled clear. An open menu
     stays put. Measured against the bar's own box, which keeps its size while hidden. */
  const bar = root.querySelector('.pl-help__bar') || root;
  const KEEP_CLEAR = '[data-pl-atc], .pl-pdp__cta, .pl-card__addbtn, .pl-cpair__add, [name="checkout"], .pl-inq button[type="submit"]';
  const PAD = 12;
  const clearCheck = () => {
    let hit = false;
    if (!root.classList.contains('is-open')) {
      const hb = bar.getBoundingClientRect();
      for (const el of document.querySelectorAll(KEEP_CLEAR)) {
        if (el.offsetParent === null) continue;
        const r = el.getBoundingClientRect();
        if (r.right > hb.left - PAD && r.left < hb.right + PAD && r.bottom > hb.top - PAD && r.top < hb.bottom + PAD) {
          hit = true;
          break;
        }
      }
    }
    document.documentElement.classList.toggle('pl-help-clear', hit);
  };
  if (window.PL && window.PL.onScroll) {
    window.PL.onScroll(clearCheck);
  } else {
    addEventListener('scroll', clearCheck, {passive: true});
    addEventListener('resize', clearCheck, {passive: true});
    clearCheck();
  }
  /* options change the buy row's height and the sticky bar lifts the menu: check again after either */
  document.addEventListener('change', () => requestAnimationFrame(clearCheck));
  setInterval(clearCheck, 1000);
})();
